/**
 * Очередь Фабрики платежей для шапки Финансиста и пульта Финдиректора: заявки от проверки
 * до согласования Гендиректором, ещё не выгруженные в банк. Число и сумма — по одним и тем
 * же заявкам. Модуль без импортов — проверяется node:test (`paymentQueue.test.mjs`).
 */

/** Поля сводки пульта (`payment_factory`), из которых складывается очередь. */
export interface PaymentQueueSource {
  in_review_count: number;
  ready_for_ceo_count: number;
  on_ceo_approval_count: number;
  approved_ready_for_1c_count: number;
  total_in_review_amount: number;
  /** Сумма заявок «Готово для Гендиректора» — с предупреждениями проверок и без. */
  total_passed_gates_amount: number;
  total_on_ceo_approval_amount: number;
  total_approved_amount: number;
}

export interface PaymentQueue {
  count: number;
  amount: number;
}

/** На проверке у Финансиста, готово для Гендиректора, у Гендиректора и согласовано. Не
 *  входят черновики, отложенные, отклонённые и уже выгруженные в банк. */
export function paymentQueue(pf: PaymentQueueSource): PaymentQueue {
  return {
    count:
      pf.in_review_count +
      pf.ready_for_ceo_count +
      pf.on_ceo_approval_count +
      pf.approved_ready_for_1c_count,
    amount:
      pf.total_in_review_amount +
      pf.total_passed_gates_amount +
      pf.total_on_ceo_approval_amount +
      pf.total_approved_amount,
  };
}
